import { useState } from "react";
import PropTypes from "prop-types";
import AddBrandedFeatureFlag from "./AddBrandedFeatureFlag";
import BrandedFeatureFlagTable from "./Table";

const BrandedFeatureFlags = ({ brandedFeatureFlags, brands, features }) => {
  const [bffs, setBffs] = useState(brandedFeatureFlags);

  return (
    <div className="user-content">
      <div className="content-wrap">
        <div className="container">
          <div className="row">
            <div className="panel">
              <div className="panel-header">Branded Feature Flags</div>

              <div className="panel-body">
                <BrandedFeatureFlagTable brandedFeatureFlags={bffs} setBffs={setBffs} />

                <AddBrandedFeatureFlag brands={brands} features={features} setBffs={setBffs} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

BrandedFeatureFlags.propTypes = {
  brands: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  brandedFeatureFlags: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  features: PropTypes.arrayOf(PropTypes.shape()).isRequired,
};
export default BrandedFeatureFlags;
